import router from '../../router'
import moment from 'moment'

export const news = {
    state: {
        filters: {
            dateFrom: {
                type: 'range-date',
                range: 'from',
                text: 'Od',
                title: 'Data',
                additionalText: 'Data od',
                value: '',
                groupName: 'range'
            },
            dateTo: {
                type: 'range-date',
                range: 'to',
                text: 'Do',
                additionalText: 'Data do',
                value: '',
                groupName: 'range'
            }
        },
        status: 'idle',
        news: null,
        newsHeader: null,
        pagination: {
            count: null,
            limit: 10,
            offset: 0,
            total: null,
            totalPages: null
        },
        alerts: null,
        activeNews: null
    },
    mutations: {
        RESET_NEWS_FILTERS(state, payload) {
            state.filters = payload
        },
        SET_NEWS_FILTER(state, payload) {
            state.filters[payload.filter].value = payload.value
        },
        SET_NEWS(state, payload) {
            state.news = payload
        },
        SET_ALERTS(state, payload) {
            state.alerts = payload
        },
        SET_NEWS_HEADER(state, payload) {
            state.newsHeader = payload
        },
        SET_NEWS_STATUS(state, payload) {
            state.status = payload
        },
        SET_NEWS_PAGINATION(state, payload) {
            state.pagination = payload
        },
        SET_NEWS_OFFSET(state, payload) {
            state.pagination.offset = payload
        },
        SET_ACTIVE_NEWS(state, payload) {
            state.activeNews = payload
        }
    },
    actions: {
        newsFetch(
            { commit, state, getters },
            payload = { limit: undefined, offset: undefined }
        ) {
            commit('SET_NEWS_STATUS', 'loading')

            const currentDate = new Date()
            const dateFrom = moment(currentDate)
                .subtract(12, 'months')
                .format('DD-MM-YYYY HH:mm')

            let params = { dateFrom }

            if (payload && isNaN(payload.limit) && isNaN(payload.offset)) {
                if (router.currentRoute.query.page) {
                    commit(
                        'SET_NEWS_OFFSET',
                        (+router.currentRoute.query.page - 1) *
                            state.pagination.limit
                    )
                }
            }
            const offset = !isNaN(payload.offset)
                ? payload.offset
                : state.pagination.offset
            const limit = !isNaN(payload.limit)
                ? payload.limit
                : state.pagination.limit

            const filters = {}

            Object.keys(state.filters).map((filter, idx) => {
                if (state.filters[filter].value) {
                    const value = state.filters[filter].value
                    if (moment(value).isValid()) {
                        const time = filter === 'dateFrom' ? '00:00' : '23:59'
                        filters[filter] = moment(value).format(
                            `DD-MM-YYYY ${time}`
                        )
                    } else {
                        filters[filter] = value
                    }
                }
            })

            params = { ...params, limit, offset, ...filters }

            const userId = getters.userId

            return this.$api(`news/user/${userId}`, { params })
                .then(res => {
                    if (payload && payload.limit && payload.limit === 5) {
                        commit('SET_NEWS_HEADER', res.data.data.news)
                    } else {
                        commit('SET_NEWS', res.data.data.news)
                        commit('SET_NEWS_PAGINATION', {
                            ...res.data.data.resultSet,
                            totalPages: Math.ceil(
                                res.data.data.resultSet.total /
                                    res.data.data.resultSet.limit
                            )
                        })
                    }
                    commit('SET_NEWS_STATUS', 'idle')
                })
                .catch(() => {
                    commit('SET_NEWS_STATUS', 'idle')
                })
        },
        alertsFetch({ commit, dispatch, getters }) {
            const userId = getters.userId

            const params = {
                read: false,
                type: 'ALERT'
            }

            return this.$api(`news/user/${userId}`, {
                params
            }).then(res => {
                if (res.data?.data?.news?.length) {
                    commit('SET_ALERTS', res.data.data.news)
                    dispatch('openModal', {
                        component: 'ModalAlerts'
                    })
                }
            })
        },
        removeFirstAlert({ state, commit }) {
            commit('SET_ALERTS', state.alerts.slice(1))
        },
        markOneNewsAsRead({ getters, state }, payload) {
            const userId = getters.userId
            const newsHeader = state.newsHeader.find(el => el.id === payload)
            if (newsHeader) {
                newsHeader.read = true
            }
            if (state.news) {
                const news = state.news.find(el => el.id === payload)
                if (news) {
                    news.read = true
                }
            }

            return this.$api.patch(`news/user/one/${userId}/${payload}`)
        },
        markAllNewsAsRead({ getters, state }) {
            const userId = getters.userId
            state.newsHeader.forEach(el => {
                el.read = true
            })
            state.news.forEach(el => {
                el.read = true
            })

            return this.$api.patch(`news/user/${userId}`)
        },
        removeSingleNews({ getters, state, commit }, payload) {
            const userId = getters.userId

            return new Promise((resolve, reject) => {
                this.$api
                    .delete(`news/user/${userId}/${payload}`)
                    .then(res => {
                        if (res.response && res.response.status !== 200) {
                            throw new Error(res.response.data.message)
                        }
                        const filteredNews = state.news.filter(
                            news => news.id !== payload
                        )
                        commit('SET_NEWS', filteredNews)
                        resolve(res)
                    })
                    .catch(err => reject(err))
            })
        },
        setActiveNews({ commit }, payload) {
            commit('SET_ACTIVE_NEWS', payload)
        },
        setNewsOffset({ commit }, payload) {
            commit('SET_NEWS_OFFSET', payload)
        }
    },
    getters: {
        getNewsHeader: state => {
            if (state.newsHeader) {
                return state.newsHeader
            }
        },
        getNewsStatus: state => {
            return state.status
        },
        getNews: state => {
            if (state.news) {
                return state.news
            }
        },
        getAlerts: state => {
            if (state.alerts) {
                return state.alerts
            }
        },
        getNewsPagination: state => {
            return state.pagination
        },
        getActiveNews: state => {
            return state.activeNews
        },
        getFirstAlert: state => {
            if (state.alerts) {
                return state.alerts[0]
            }
        },
        getNewsFilters: state => {
            return state.filters
        }
    }
}
